import {fromJS} from 'immutable';
import {loop, Effects} from 'redux-loop-symbol-ponyfill';

import {
  GET_DEPARTMENTS_REQUEST,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAILURE,
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILURE,
  GET_PRODUCT_DETAILS_REQUEST,
  GET_PRODUCT_DETAILS_SUCCESS,
  GET_PRODUCT_DETAILS_FAILURE,
  GET_BEST_SELLER_REQUEST,
  GET_BEST_SELLER_SUCCESS,
  GET_BEST_SELLER_FAILURE,
  GET_NEW_ARRIVAL_REQUEST,
  GET_NEW_ARRIVAL_SUCCESS,
  GET_NEW_ARRIVAL_FAILURE,
  GET_SEARCH_REQUEST,
  GET_SEARCH_SUCCESS,
  GET_SEARCH_FAILURE,
  GET_FEATURED_REQUEST,
  GET_FEATURED_SUCCESS,
  GET_FEATURED_FAILURE,
  SET_SIMILAR_PEODUCTS,
  GET_PRODUCT_FILTERS_REQUEST,
  GET_PRODUCT_FILTERS_SUCCESS,
  GET_PRODUCT_FILTERS_FAILURE,
  SET_LIST_PAGE_STATE,
  SET_SEARCH_RESULT_LIST_PAGE_STATE,
  GET_PRODUCT_SEARCH_FILTERS_REQUEST,
  GET_PRODUCT_SEARCH_FILTERS_SUCCESS,
  GET_PRODUCT_SEARCH_FILTERS_FAILURE,
  GET_SPECIALS_REQUEST,
  GET_SPECIALS_SUCCESS,
  GET_SPECIALS_FAILURE
} from '../actions/productsActions';

// Initial state
const initialState = fromJS({loading: false, error: {}, products: [], similarProducts: [], listPageState: {}});

// Reducer
export default function ProductsReducer(state = initialState, action = {}) {

  switch (action.type) {
    case GET_PRODUCTS_REQUEST:
      return state.set('loading', true).set('products', [])
    case GET_PRODUCTS_SUCCESS:
      return state.set('loading', false).set('products', action.payload)

    case GET_PRODUCT_FILTERS_REQUEST:
    case GET_PRODUCT_SEARCH_FILTERS_REQUEST:
      return state.set('loading', true).set('error', false)
    case GET_PRODUCT_FILTERS_SUCCESS:
    case GET_PRODUCT_SEARCH_FILTERS_SUCCESS:
      return state.set('loading', false)

    case GET_SPECIALS_REQUEST:
      return state.set('loading', true).set('specials', [])
    case GET_SPECIALS_SUCCESS:
      return state.set('loading', false).set('specials', action.payload)

    case GET_BEST_SELLER_REQUEST:
      return state.set('loading', true).set('bestSellers', [])
    case GET_BEST_SELLER_SUCCESS:
      return state.set('loading', false).set('bestSellers', action.payload)

    case GET_NEW_ARRIVAL_REQUEST:
      return state.set('loading', true).set('newArrivals', [])
    case GET_NEW_ARRIVAL_SUCCESS:
      return state.set('loading', false).set('newArrivals', action.payload)

    case GET_SEARCH_REQUEST:
      return state.set('searchResults', [])
    case GET_SEARCH_SUCCESS:
      return state.set('searchResults', action.payload)

    case GET_FEATURED_REQUEST:
      return state.set('loading', true).set(`featured_${action.department}`, [])
    case GET_FEATURED_SUCCESS:
      return state.set('loading', false).set(`featured_${action.department}`, action.payload)

    case GET_DEPARTMENTS_REQUEST:
      return state.set('loading', true)
    case GET_DEPARTMENTS_SUCCESS:
      return state.set('loading', false).set('departments', action.payload)

    case GET_PRODUCT_DETAILS_REQUEST:
      return state.set('loading', true).set('recentProduct', {})
    case GET_PRODUCT_DETAILS_SUCCESS:
      return state.set('loading', false).set('recentProduct', action.payload)

    case SET_SIMILAR_PEODUCTS:
      return state.set('similarProducts', action.payload);

    case SET_LIST_PAGE_STATE:
      return state.set('listPageState', action.payload);
    case SET_SEARCH_RESULT_LIST_PAGE_STATE:
      return state.set('searchResultListState', action.payload);

    case GET_PRODUCTS_FAILURE:
    case GET_DEPARTMENTS_FAILURE:
    case GET_PRODUCT_DETAILS_FAILURE:
    case GET_BEST_SELLER_FAILURE:
    case GET_NEW_ARRIVAL_FAILURE:
    case GET_SEARCH_FAILURE:
    case GET_FEATURED_FAILURE:
    case GET_PRODUCT_FILTERS_FAILURE:
    case GET_PRODUCT_SEARCH_FILTERS_FAILURE:
    case GET_SPECIALS_FAILURE:
      return state.set('error', action.payload).set('loading', false)
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/productsReducer.js